<form
  [formGroup]="form"
  [alAnchor]="tutorSetting?.variable_name ? 'setting.' + tutorSetting?.variable_name : null"
  class="grid"
  [class.grid--stacked]="isFullWidth"
  [class.grid--coming-soon]="isComingSoon"
  [class.grid--readonly]="disabled"
>
  <label class="label col-form-label">
    {{ "enums.aiConfiguration." + tutorSetting?.name | translate }}
    <!-- One icon per row: a locked setting shows why it is locked instead
         of its regular hint — two icons wrapped onto a second line. -->
    <nb-icon
      *ngIf="popoverKey"
      icon="question-mark-circle-outline"
      class="hint-icon"
      nbPopover="{{ popoverKey | translate }}"
      nbPopoverTrigger="hover"
      nbPopoverPlacement="bottom"
    ></nb-icon>
    <span *ngIf="isComingSoon" class="coming-soon-badge">
      {{ 'pages.tutors.comingSoon' | translate }}
    </span>
  </label>

  <div class="control">
    <!-- `default_language` is a text setting holding an ISO code; it gets
         the searchable language picker instead of a free-text field. -->
    <app-language-select
      *ngIf="isLanguageSetting"
      formControlName="value"
    ></app-language-select>
    <ng-container *ngIf="!isLanguageSetting" [ngSwitch]="tutorSetting?.field_type">
      <!-- Classic short text (actually a 1-line textarea for legacy compat) -->
      <textarea
        *ngSwitchCase="'text'"
        type="text"
        nbInput
        fullWidth
        formControlName="value"
      ></textarea>

      <!-- alpha_flexible: multi-line prompt blocks -->
      <textarea
        *ngSwitchCase="'longtext'"
        nbInput
        fullWidth
        formControlName="value"
        rows="6"
      ></textarea>

      <textarea
        *ngSwitchCase="'code'"
        nbInput
        fullWidth
        formControlName="value"
        rows="10"
        class="code-field"
      ></textarea>

      <input
        *ngSwitchCase="'int'"
        nbInput
        fullWidth
        type="number"
        formControlName="value"
        [min]="tutorSetting?.validation?.min ?? 0"
        [max]="tutorSetting?.validation?.max ?? 9999999"
      />

      <div *ngSwitchCase="'slider'" class="slider-row">
        <input
          type="range"
          formControlName="value"
          [min]="tutorSetting?.validation?.min ?? 0"
          [max]="tutorSetting?.validation?.max ?? 1"
          [step]="tutorSetting?.validation?.step ?? 0.1"
          class="slider-input"
        />
        <span class="slider-value">{{ form.get("value")?.value }}</span>
      </div>

      <div *ngSwitchCase="'boolean'" class="toggle-row">
        <nb-toggle formControlName="value"></nb-toggle>

        <nb-select
          *ngIf="linkedSetting"
          [formGroup]="linkedForm"
          formControlName="value"
          multiple="true"
          [disabled]="!toggleOn"
          class="linked-select"
          [class.disabled]="!toggleOn"
        >
          <nb-option *ngFor="let v of linkedSetting.options" [value]="v">{{ v }}</nb-option>
        </nb-select>
      </div>

      <nb-select
        *ngSwitchCase="'dropdown'"
        formControlName="value"
        [placeholder]="
          'enums.aiConfigurationPlaceholders.' + tutorSetting?.name | translate
        "
      >
        <nb-option *ngFor="let v of tutorSetting?.options" [value]="v">
          {{ "enums." + tutorSetting?.name + "." + v | translate }}
        </nb-option>
      </nb-select>

      <nb-select
        *ngSwitchCase="'multi-select'"
        formControlName="value"
        multiple="true"
      >
        <nb-option *ngFor="let v of tutorSetting?.options" [value]="v">
          {{ "enums." + tutorSetting?.name + "." + v | translate }}
        </nb-option>
      </nb-select>

      <!-- Fallback for unknown field_type → plain text input -->
      <input *ngSwitchDefault nbInput fullWidth formControlName="value" />
    </ng-container>
  </div>
</form>
